export default __webpack_public_path__ + "static/media/sortdlogol.30bff8c9.png";